import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

const Home = () => {
  const navigate = useNavigate();

  const videoRef = useRef(null);
  const videoMobileRef = useRef(null);
  const serviceRefs = useRef([]);
  const headingRef = useRef(null);
  const brandsHeadingRef = useRef(null);
  const brandRefs = useRef([]);
  const counterRefs = useRef([]);
  const cardsRef = useRef([]);

  const [countersStarted, setCountersStarted] = useState(false);
  const [counts, setCounts] = useState([0, 0, 0, 0]);

  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (videoRef.current) videoRef.current.muted = true;
    if (videoMobileRef.current) videoMobileRef.current.muted = true;
  }, []);

  const getActiveVideo = () => (isMobile ? videoMobileRef.current : videoRef.current);

  const handleVideoClick = () => {
    const video = getActiveVideo();
    if (video && video.paused) {
      video.play();
      setIsPlaying(true);
    } else if (video) {
      video.pause();
      setIsPlaying(false);
    }
  };

  const toggleMute = () => {
    const muted = !isMuted;
    setIsMuted(muted);
    if (videoRef.current) videoRef.current.muted = muted;
    if (videoMobileRef.current) videoMobileRef.current.muted = muted;
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.target?.classList) {
            entry.target.classList.add("show");

            if (counterRefs.current.includes(entry.target) && !countersStarted) {
              startCounting();
              setCountersStarted(true);
            }
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (headingRef.current) observer.observe(headingRef.current);
    if (brandsHeadingRef.current) observer.observe(brandsHeadingRef.current);
    serviceRefs.current.forEach((card) => card && observer.observe(card));
    brandRefs.current.forEach((logo) => logo && observer.observe(logo));
    counterRefs.current.forEach((counter) => counter && observer.observe(counter));

    return () => {
      if (headingRef.current) observer.unobserve(headingRef.current);
      if (brandsHeadingRef.current) observer.unobserve(brandsHeadingRef.current);
      serviceRefs.current.forEach((card) => card && observer.unobserve(card));
      brandRefs.current.forEach((logo) => logo && observer.unobserve(logo));
      counterRefs.current.forEach((counter) => counter && observer.unobserve(counter));
    };
  }, [countersStarted]);

  useEffect(() => {
    const observerOptions = { root: null, rootMargin: "0px", threshold: 0.5 };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.target?.classList) {
          entry.target.classList.add("visible");
        }
      });
    }, observerOptions);

    cardsRef.current.forEach((card, idx) => {
      if (card && idx !== 0) observer.observe(card);
    });

    if (cardsRef.current.length > 0 && cardsRef.current[0]?.classList) {
      cardsRef.current[0].classList.add("first-visible");
    }

    return () => {
      cardsRef.current.forEach((card) => card && observer.unobserve(card));
    };
  }, []);

  const startCounting = () => {
    const targetValues = [35, 126, 261, 5];
    targetValues.forEach((target, index) => {
      let start = 0;
      const duration = 2000;
      const stepTime = Math.max(Math.floor(duration / target), 20);

      const timer = setInterval(() => {
        start += Math.ceil(target / (duration / stepTime));
        if (start >= target) {
          start = target;
          clearInterval(timer);
        }
        setCounts((prev) => {
          const newCounts = [...prev];
          newCounts[index] = start;
          return newCounts;
        });
      }, stepTime);
    });
  };

  const cardsData = [
    {
      number: "01",
      title: "Vision &\nStrategy",
      desc: "We define a clear vision aligned with your long-term goals and build a strategic roadmap that transforms ideas into measurable success.",
    },
    {
      number: "02",
      title: "Plan &\nStrategize",
      desc: "From branding to marketing, we craft a tailored roadmap to We understand your goals—whether you're a brand or a on the Plaet",
    },
    {
      number: "03",
      title: "Create &\nCollaborate",
      desc: "Our team works closely with you to transform ideas into reality through creativity, seamless communication, and strong collaboration."
    },
    {
      number: "04",
      title: "Grow &\nOptimize",
      desc: "We understand your goals—whether you're a brand or a on the Plaet before that World has been into this Session",
    },
  ];

  return (
    <div>
      <div className="video-container">
        {isMobile ? (
          <video
            ref={videoMobileRef}
            className="background-video mobile-video"
            autoPlay
            loop
            muted={isMuted}
            onClick={handleVideoClick}
            playsInline
            preload="auto"
          >
            <source src="/vedios/zzayraat vertical final.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <video
            ref={videoRef}
            className="background-video desktop-video"
            autoPlay
            loop
            muted={isMuted}
            onClick={handleVideoClick}
            playsInline
            preload="auto"
          >
            <source src="/vedios/video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}
        <button
          className="music-toggle-btn"
          onClick={toggleMute}
          aria-label={isMuted ? "Unmute video" : "Mute video"}
        >
          {isMuted ? "Music Off" : "Music On"}
        </button>
      </div>

      <section className="what-defines-us">
        <div className="container">
          <div className="content">
            <h2>
               Whats Defines Us
            </h2>
            <p>
              ZZAYRAAT is defined by creativity, clarity and a commitment to quality. We turn ideas into powerful digital experiences through smart marketing, strong visuals and meaningful brand storytelling. Our work blends innovation with strategy to help businesses grow with trust, consistency and measurable impact.
            </p>
          </div>
          <div className="images">
            <img src="/images/your-image3.jpg" alt="Team Work 1" className="img1" />
            <img src="/images/your-image1.jpg" alt="Team Work 2" className="img2" />
            <img src="/images/your-image.jpg" alt="Team Work 3" className="img3" />
          </div>
        </div>
      </section>

      <section className="brand-slider-section">

  <h2 className="brand-slider-heading">
    WE ARE WORKING WITH
  </h2>

  {/* --- SLIDER 1 (Logos 1 to 11) --- */}
  <div className="brand-slider-container">
    <div className="brand-slider-track">
      {[
        "/images/1.jpg",
        "/images/2.jpg",
        "/images/3.jpg",
        "/images/4.jpg",
        "/images/5.jpg",
        "/images/18.jpg",
        "/images/7.jpg",
        "/images/8.jpg",
        "/images/9.jpg",
        "/images/10.jpg",
        "/images/11.jpg",
        "/images/1.jpg",
        "/images/2.jpg",
        "/images/3.jpg",
        "/images/4.jpg",
        "/images/5.jpg",
        "/images/18.jpg",
        "/images/7.jpg",
        "/images/8.jpg",
        "/images/9.jpg",
        "/images/10.jpg",
        "/images/11.jpg",
      ].map((logo, index) => (
        <div className="brand-slide" key={index}>
          <img src={logo} alt={`brand-${index}`} className="brand-logo" />
        </div>
      ))}
    </div>
  </div>

  {/* --- SLIDER 2 (Logos 12 to 24) --- */}
  <div className="brand-slider-container">
    <div className="brand-slider-track reverse"> {/* reverse direction */}
      {[
        "/images/12.jpg",
        "/images/13.jpg",
        "/images/14.jpg",
        "/images/15.jpg",
        "/images/16.jpg",
        "/images/17.jpg",
        "/images/6.jpg",
        "/images/19.jpg",
        "/images/20.jpg",
        "/images/21.jpg",
        "/images/22.jpg",
        "/images/23.jpg",
        "/images/24.jpg",
        "/images/12.jpg",
        "/images/13.jpg",
        "/images/14.jpg",
        "/images/15.jpg",
        "/images/16.jpg",
        "/images/17.jpg",
        "/images/6.jpg",
        "/images/19.jpg",
        "/images/20.jpg",
        "/images/21.jpg",
        "/images/22.jpg",
        "/images/23.jpg",
        "/images/24.jpg",
      ].map((logo, index) => (
        <div className="brand-slide" key={index}>
          <img src={logo} alt={`brand2-${index}`} className="brand-logo" />
        </div>
      ))}
    </div>
  </div>

</section>


      <section className="our-services">
        <div className="services-container">
          <h2 className="services-heading hidden" ref={headingRef}>
            Services We Provide
          </h2>

          <div className="services-grid">
            {[
               {
                icon: "📢",
                title: "Branding & PR",
                text: "Your brand deserves to be seen. We build identities, stories, and strategies that make your brand stand out with trust and clarity.",
              },
              {
                icon: "💻",
                title: "Marketing",
                text: "We create marketing campaigns that work. From visibility to conversion, we help your business grow with targeted and effective digital strategies.",
              },
              
              {
                icon: "🎥",
                title: "Media production",
                text: "We turn ideas into powerful visuals. Our team delivers high quality shoots, content, and creative storytelling that elevate your brand presence.",
              },
              {
                icon: "📈",
                title: "Technology",
                text: "We bring smart tech solutions to your business. From digital tools to automation, we help you work faster, scale better, and deliver a superior customer experience.",
              },
              
            ].map((service, index) => (
              <div
                key={index}
                className="service-card hidden"
                ref={(el) => (serviceRefs.current[index] = el)}
              >
                <span className="service-icon">{service.icon}</span>
                <h3 className="service-title">{service.title}</h3>
                <p>{service.text}</p>
              </div>
            ))}
          </div>
          <div className="services-btn">
            <button onClick={() => navigate("/our-services")}>
              Explore All Services &gt;&gt;
            </button>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="stats-container">
          {[
            { number: counts[0], label: "Brands Served" },
            { number: counts[1], label: "Successful Campaigns" },
            { number: counts[2], label: "Creative Shoots Completed" },
            { number: counts[3], label: "Years of Digital Experience" },
          ].map((stat, index) => (
            <div
              key={index}
              className="stat-card hidden"
              ref={(el) => (counterRefs.current[index] = el)}
            >
              <h2 className="stat-number">{stat.number.toLocaleString()}+</h2>
              <p className="stat-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="rolling-section">
  <div className="rolling-header">
    <h2 className="rolling-main-title">Here's how we get things rolling</h2>
          <p style={{ color: '#888', fontSize: '1.1rem', marginTop: '10px', marginBottom: '40px', alignContent: 'center', textAlign:"center" ,fontSize: '30px' }}>
          Our Services: From Idea to Impact
        </p>
    <div className="rolling-divider"></div>
  </div>

  <div className="rolling-container">
    {cardsData.map(({ number, title, desc }, idx) => (
      <div key={number} className="pro-card">
        <div className="pro-card-layout">
          {/* The blue number from your drawing */}
          <span className="pro-number">{number}</span>
          
          <div className="pro-content">
            <h3 className="pro-title">{title}</h3>
            <div className="pro-dropdown-area">
              <p className="pro-description">{desc}</p>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
</section>
    </div>
  );
};

export default Home;
